import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

import RoundButton from "core/Components/Buttons/RoundButton";

type Props = {
    data: BannerWithFullImage
};

const FirstButton: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();

    const linkURL = data.innerURL || data.outerURL;
    const colourTheme = JSON.parse(data.theme);
    const { buttonTextColour, buttonColour, } = colourTheme;

    const buttonTextCustomStyle = css`
        font-size: 20px;

        ${theme.breakpoints.up("3xl")} {
            font-size: 25px;
        }

        ${theme.breakpoints.down("sm")} {
            font-size: 16px;
        }
    `;

    if (!data.buttonText) return null;

    return (
        <RoundButton
            backgroundColour={data.buttonColour || buttonColour}
            textColour={data.buttonTextColour || buttonTextColour}
            buttonHoverColour={data.buttonHoverColour}
            textHoverColour={data.buttonTextHoverColour}
            linkURL={linkURL}
            buttonTextCustomStyle={buttonTextCustomStyle}
        >
            {data.buttonText}
        </RoundButton>
    );
}

export default FirstButton;
